// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iRJUgaT6lzCH56 {
  display: flow-root;
  position: relative;
  z-index: 10;
  min-height: 24px;
  padding: var(--ds-space-100, 8px) var(--ds-space-150, 12px) var(--ds-space-050, 4px);
}
.eI3Aw9JvmKV7xQ {
  padding-right: var(--ds-space-100, 8px);
}
.KA7tp5jGpI_dGY {
  margin-bottom: var(--ds-space-050, 4px);
}
.pRkPmKlO4ksnzD {
  color: var(--ds-text, #172b4d);
  font-size: 11px;
  line-height: 14px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"details": `iRJUgaT6lzCH56`,
	"spinner": `eI3Aw9JvmKV7xQ`,
	"aiInProgress": `KA7tp5jGpI_dGY`,
	"aiInProgressText": `pRkPmKlO4ksnzD`
};
export default ___CSS_LOADER_EXPORT___;
